/* eslint-disable */ 

export default {
    state: { 
        reset: {
            loading: false,
            errMessage: "",
            successMessage: ""
        }
    },
    mutations: {
        'FORGOT_RESET_LOADING': (state, val) => {
            state.reset.loading = val;
        },
        'FORGOT_RESET_SUCCESS': (state, val) => {
            state.reset.errMessage = "";
            state.reset.successMessage = val;
        },
        'FORGOT_RESET_ERROR': (state, val) => {
            state.reset.errMessage = val;
            state.reset.successMessage = "";
        }
    },
    actions: {
        'FORGOT_RESET_SUBMIT': ({commit, rootState}, payload) => {
            commit('FORGOT_RESET_LOADING', true);
            axios.get('/reset', {params: {email: payload.email}})
                .then(resp => {
                    commit('FORGOT_RESET_LOADING', false);
                    commit('FORGOT_RESET_SUCCESS', rootState.locale === "en" ? "Success! You will shortly recieve an email with password reset link.":"Onnistui! Saat pian sähköpostin, joka sisältää linkin salasanan vaihtamiseksi.");
                    console.log(resp);
                })
                .catch(err => {
                    commit('FORGOT_RESET_LOADING', false);
                    const errTxt = err.response ? (err.response.data ? (err.response.data.errTxt ? err.response.data.errTxt : undefined): undefined) : undefined;
                    const enText = errTxt ? errTxt : "Error, something went wrong try again.", fiText = errTxt ? errTxt : "Virhe, jokin meni pieleen.";
                    commit('FORGOT_RESET_ERROR',  rootState.locale === "en" ? enText : fiText);
                    console.log(err.response);
                });
        }
    }
}